var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, Select, MenuItem, Typography, InputLabel } from "@mui/material";
import { ST_NavBar_SelectBox } from "../../css/NavigationObjectCss";
//i18n engine
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
//language List file
import { LanguageList } from "./languages/LanguagesList";
// package for flag
import CountryFlag from "react-country-flag";
import { useState } from "react";
import { useDeviceQueries } from "../../shared/Utilites";
var languageCodeToFlagCode = {
    en: "gb",
    ms: "my",
    ja: "jp",
};
export function SelectLanguage(props) {
    var _a, _b;
    var _c = useState(((_a = i18n.language) === null || _a === void 0 ? void 0 : _a.includes("-")) ? (_b = i18n.language) === null || _b === void 0 ? void 0 : _b.split("-")[0] : i18n.language), selected = _c[0], setSelected = _c[1];
    var isMobile = useDeviceQueries();
    return (_jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(Box, { children: _jsxs(FormControl, __assign({ fullWidth: true, sx: { mt: isMobile ? 0 : 1, minWidth: isMobile ? 120 : 120 }, size: "small" }, { children: [!selected && _jsx(InputLabel, __assign({ htmlFor: "demo-select-small" }, { children: "Select Language" })), _jsx(Select, __assign({ value: selected, labelId: "demo-select-small", sx: __assign({ boxShadow: "none", color: "black", backgroundColor: (props === null || props === void 0 ? void 0 : props.fromLoginComponent) ? "#FFFFFF" : "#F5F5F5" }, ((props === null || props === void 0 ? void 0 : props.fromLoginComponent) ? {} : ST_NavBar_SelectBox)), onChange: function (event) {
                            setSelected(event.target.value);
                            i18n.changeLanguage(event.target.value);
                        } }, { children: LanguageList === null || LanguageList === void 0 ? void 0 : LanguageList.map(function (language, index) {
                            var _a;
                            return (_jsx(MenuItem, __assign({ value: language === null || language === void 0 ? void 0 : language.code }, { children: _jsxs(Box, __assign({ sx: { display: "flex", alignItems: "center" } }, { children: [_jsx(CountryFlag, { style: { marginRight: 8 }, countryCode: (_a = languageCodeToFlagCode[language === null || language === void 0 ? void 0 : language.code]) !== null && _a !== void 0 ? _a : language === null || language === void 0 ? void 0 : language.code, svg: true }), _jsx(Typography, { children: language === null || language === void 0 ? void 0 : language.name })] })) }), index));
                        }) }))] })) }) })));
}
